import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

// Service
import { ProFunnelModel } from "../../../../model/builk/profunnel/profunnel.model";
import { ProFunnelListModel } from "../../../../model/builk/profunnel/profunnel-list.model";
import { ProFunnelBadgeComponent } from "../profunnel-badge/profunnel-badge.component";
import { ISubscription } from "rxjs/Subscription";
import { ProFunnelService } from "../../../../service/api/builk/profunnel.service";
import { ProFunnelProjectComponent } from "../profunnel-project/profunnel-project.component";
import { AddressService } from "../../../../service/api/builk/address.service";
import { SelectorModel } from "../../../../model/shared/selector.model";

@Component({
  selector: "bo-builk-profunnel-table",
  templateUrl: "./profunnel-table.component.html",
  styleUrls: ["./profunnel-table.component.scss"]
})
export class ProFunnelTableComponent implements OnInit, OnDestroy {
  // string
  currentCountry: string;
  currentSortColumn: string = "Id";

  // boolean
  sortByDesc: boolean = true;
  // Company Type List
    companyTypeList = [{
            id: 1,
            companyType: "General Contractor"
        }, {
            id: 2,
            companyType: "Heavy Construction Contractor"
        }, {
            id: 3,
            companyType: "M&E Contractor"
        }, {
            id: 4,
            companyType: "Building Contractor"
        }, {
            id: 5,
            companyType: "Specialty Contractor"
        }, {
            id: 6,
            companyType: "Interior/Decorate/Landscape Contractor"
        }, {
            id: 7,
            companyType: "Home Building Contractor"
        }, {
            id: 8,
            companyType: "Miscellaneous"
        }, {
            id: 9,
            companyType: "Highway/Road Construction Contractor"
        }, {
            id: 10,
            companyType: "Material Supplier/Reseller"
        }, {
            id: 11,
            companyType: "Material Manufacturer"
        }, {
            id: 12,
            companyType: "ผู้รับเหมาซ่อมแซมอาคาร"
        }, {
            id: 13,
            companyType: "Designer"
        }, {
            id: 14,
            companyType: "Consultant"
        }, {
            id: 15,
            companyType: "building contractor"
        }
  ];

  provinceList: Array<SelectorModel> = [];
  constructor(
    public router: Router,
    public proFunnelService: ProFunnelService,
    private readonly addressService: AddressService
  ) { }

  private _data = new BehaviorSubject<Array<ProFunnelModel>>(
    new Array<ProFunnelModel>()
  );
  @Input()
  set getProFunnelDataIndex(value) {
    this._data.next(value);
  }
  @Input()
  set country(config: {country: string, lang: string}) {
    this.getProvinceByCountry(config.country, config.lang);
  }
  get getProFunnelDataIndex(): Array<ProFunnelModel> {
    return this._data.getValue();
  }

  proFunnelResult: ProFunnelListModel = new ProFunnelListModel();

  @ViewChild("detailModal") detailModal: ProFunnelBadgeComponent;
  @ViewChild("projectModal") projectModal: ProFunnelProjectComponent;
  @Output() readonly setProFunnelList = new EventEmitter<ProFunnelModel>();
  @Output() readonly sortByColumn = new EventEmitter<any>();

  proFunnelDetail: ProFunnelModel = new ProFunnelModel();
  proFunnelBadge: ProFunnelBadgeComponent;
  proFunnel: ProFunnelModel = new ProFunnelModel();
  subscription: ISubscription;

  ngOnInit(): void {
    this._data.subscribe(x => { });
  }

  openModal(id): void {
    this.detailModal.openModal(id);
  }
  openModalByModel(data): void {
    this.detailModal.openModalByModel(data);
  }

  // validate by id
  updateComment(id: number, comment: string): void {
    this.proFunnel.comment = comment;
    this.proFunnel.id = id;
    this.subscription = this.proFunnelService.updateCommentProFunnelBackOffice(this.proFunnel)
      .subscribe(
        Response => {
        },
        err => {
          // error
        }
      );
  }

  refreshProFunnel(id: number): void {
    this.proFunnelDetail.id = id;
    this.subscription = this.proFunnelService.updateProFunnelBackOffice(this.proFunnelDetail)
      .subscribe(
        Response => {
          if (Response) {
            this.setProFunnelList.emit(Response);
          }
        },
        err => {
          // error
        }
      );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getCompanyTypeName(companyType: number): string {
    let comtype = this.companyTypeList.filter(x => x.id == companyType);
    if (comtype.length > 0) {
      return comtype[0].companyType;
    }
    return '';
  }

  openCompanyProject(id: number, companyName: string) {
    this.projectModal.openModal(id, companyName);
  }

  getProvinceByCountry(country: string, lang: string) {
    if (country != this.currentCountry) {
      this.currentCountry = country;
      this.addressService.getProvince(country, lang).subscribe(res => {
        this.provinceList = res;
      });
    }
  }

  getStateName(code: string) {
    if (this.provinceList.length > 0) {
      let item = this.provinceList.filter(x => x.id == code);
      if (item.length > 0) {
        return item[0].text;
      }
    }
    return code;
  }

  onSortBy(column: string) {
    this.currentSortColumn = column;
    this.sortByDesc = !this.sortByDesc;
    let configSort = {
      sortCol: column,
      sortType: this.sortByDesc ? 1 : 0
    }
    this.sortByColumn.emit(configSort);
  }
}
